import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

export const Footer = ({
  version,
  className,
  ...props
}) => {

  const classes = classNames(
    'site-footer',
    className
  );

  return (
    <footer
      {...props}
      className={classes}
    >
        <div className={
          classNames(
            'site-footer-inner'
          )}>
          <div className="row">
            <nav className='navbar navbar-expand-lg '>
                <ul className='nav footer-lowbar'>
                <span className='navbar-text footer-text ml-10'>
                    Copyright © {new Date().getFullYear()} Circle Graphics Inc. All rights reserved.
                  </span>
                  <li className='nav-item'>
                    <div className='nav-link disabled seperator-footer-style'>|</div>
                  </li>
                  <span className='navbar-text'>
                    <Link to="https://linkedin.com/company/1108764"><i className="fa fa-linkedin-square social-style" aria-hidden="true"></i></Link>
                  </span>
                  <span className='navbar-text'>
                    <Link to="http://instagram.com/circlegraphics"><i className="fa fa-instagram social-style" aria-hidden="true"></i></Link>
                  </span>
                </ul>
                <div className='d-flex footer-bottom-right'>
                  { version }
                </div>
            </nav>
          </div>
        </div>
    </footer>
  );
}